import { InjectionToken } from '@angular/core';
import { StoreObject, TypePolicies } from '@apollo/client';

export const APOLLO_TYPE_POLICY_PROVIDERS = new InjectionToken<ApolloTypePolicyProvider[]>('ApolloTypePolicyProviders');

export interface ApolloTypePolicyProvider {
	typePolicies(): TypePolicies;
	typenameMap(): { [__typename: string]: (storeObject: Readonly<StoreObject>) => string };
}
